import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { config } from '../../common/';
import * as Offer from '../../offer';

const BaseLayout: React.FC<{}> = () => (
    <Route
        render={() => {
            return (
                <Switch>
                    <Route exact path={[`${config.BaseURL}/offers`, `${config.AlternativeBaseURL}/offers`]} component={Offer.OffersLayout} />
                    <Route path={[`${config.BaseURL}/offers/:code/:vehcode?`, `${config.AlternativeBaseURL}/offers/:code/:vehcode?`]} component={Offer.OfferLayout} />
                </Switch>
            );
        }}
    />);

export default BaseLayout;
